import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewTeacherStaffInterviewComponent } from "../../../../components/review-content/review-teacher-staff-interview/review-teacher-staff-interview.component";

@Component({
  selector: 'teacher-staff-interview-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewTeacherStaffInterviewComponent
],
  templateUrl: './teacher-staff-interview-submission.component.html',
  styleUrl: './teacher-staff-interview-submission.component.css'
})
export class TeacherStaffInterviewSubmissionComponent implements OnInit {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection10 = new EventEmitter<any>();  

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.teacherStaffInterviewData) {
      this.currentCaseId = this.teacherStaffInterviewData.case_id;
    }
  }

  submitTeacherStaffInterview(): void {
    this.onSaveSection10.emit({});
  }
}
